import {Component, Input, OnInit} from '@angular/core';
import 'rxjs/add/operator/take';

@Component({
  selector: 'app-cut-item',
  templateUrl: './cut-item.component.html',
  styleUrls: []
})
export class CutItemComponent implements OnInit {

  @Input() title: string;
  @Input() createBy: string;

  constructor() {

  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/cut/cut-item/cut-item.component.ts